module.exports = __webpack_public_path__ + "img/ch6pic3.de1f70a8.png";